import  { instance  } from "../api";

const fetchFonction = (setFonctionAttributes) => {
  
      instance.get("/api/fonction/")
      .then((result)=>  { 
        setFonctionAttributes(result.data)
       
      
     })                  
    .catch ((error) =>{console.log('error', error)
      
    })
};

export default fetchFonction;